import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import { A } from '@bootstrap-styled/v4'
import { buttonsMixins } from '@bootstrap-styled/css-mixins'
import { omit } from 'ramda'

// app components
import Button, { ButtonProps } from '../Button'

export type LinkButtonProps = {
    color?: 'fill' | 'ghost'
} & Omit<ButtonProps, 'color' | 'outline'>

const LinkButtonUnstyled: React.FC<LinkButtonProps> = ({ tag = A, color, className, ...props }) => {
    const classes = classNames(className, { [`btn-link-${color}`]: color })
    const rest = omit(['paddingX'], props)

    return <Button tag={tag} color="link" className={classes} {...rest} />
}

const LinkButton = styled(LinkButtonUnstyled)`
    && {
        padding-left: ${props => props.theme['$spacers'][2]};
        padding-right: ${props => props.theme['$spacers'][2]};
        border-radius: ${props => props.theme['$btn-border-radius']};

        &:visited {
            color: ${props => props.theme['$purple']};
        }

        &&:disabled,
        &&.disabled {
            background: transparent;
            border-color: transparent;
            color: ${props => props.theme['$gray-light']};

            &.btn-icon {
                color: inherit;
            }
        }

        /* styles of buttons link */
        &.btn-link-fill {
            ${props =>
                buttonsMixins.buttonVariant(
                    props.theme['$enable-shadows'],
                    props.theme['$link-color'],
                    'transparent',
                    'transparent',
                    props.theme['$btn-active-box-shadow'],
                    props.theme['$btn-box-shadow']
                )}

            &:hover,
            &.hover {
                background-color: ${props => props.theme['$link-hover-bg']};
                border-color: ${props => props.theme['$link-hover-bg']};
                text-decoration: none;
            }

            &:focus,
            &.focus {
                background-color: ${props => props.theme['$link-hover-bg']};
                border-color: ${props => props.theme['$link-color']};
                box-shadow: none;
                text-decoration: none;
            }
        }

        &.btn-link-ghost {
            ${props =>
                buttonsMixins.buttonVariant(
                    props.theme['$enable-shadows'],
                    props.theme['$gray'],
                    'transparent',
                    'transparent',
                    props.theme['$btn-active-box-shadow'],
                    props.theme['$btn-box-shadow']
                )}

            &:focus,
            &.focus {
                box-shadow: none;
            }

            &.btn-icon {
                color: ${props => props.theme['$link-color']};
            }
        }
    }
`

export default LinkButton
